module.exports = __webpack_public_path__ + "4d3a6f5c2bd6a436e6a1b03b246336a5.svg";